/**
 * @generated SignedSource<<1cdc4774693b0a2aaeeaa60f2a9446b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AppViewType = "ACCOUNT" | "CART" | "CHECKOUT" | "CHECKOUT_CONFIRMATION" | "COLLECTION" | "CREATE_ACCOUNT" | "FOR_YOU" | "HOME" | "HOME_LOGGED_IN" | "LOG_IN" | "LOG_OUT" | "PASSWORD_RESET" | "PDP" | "SEARCH" | "SHOPIFY_REDIRECTION" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AppClipLinkGenerator_brand$data = {
  readonly appConfig: {
    readonly appViewToUrlMappings: ReadonlyArray<{
      readonly appViewType: AppViewType;
      readonly regex: string;
      readonly url: string;
    }>;
    readonly id: string;
    readonly iosAppIdentifier: string;
  };
  readonly domain: string;
  readonly " $fragmentType": "AppClipLinkGenerator_brand";
};
export type AppClipLinkGenerator_brand$key = {
  readonly " $data"?: AppClipLinkGenerator_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppClipLinkGenerator_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppClipLinkGenerator_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "domain",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iosAppIdentifier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLBrandAppViewToURLMapping",
          "kind": "LinkedField",
          "name": "appViewToUrlMappings",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "appViewType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regex",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "32ab18bd503a4775b930e3c697b645d2";

export default node;
